<template>
    <div>

      <div class="table_card">
        <div class="table_card__head">
          <p class="table_card__head--title">Búsqueda de usuario</p>
        </div>
        <div class="table_card__body">
          <v-layout row wrap>
            <v-flex xs6 row>
              <v-form onSubmit="return false;" ref="form" v-model="valid" lazy-validation>
                <input
                  v-model="searching_data"
                  placeholder="Ingrese el documento del usuario o email"
                  required
                  class="input_solid"
                  style="width: 98% !important"
                >
                <img
                  src="@/assets/img/icons/search-icon.svg"
                  class="button_search"
                  style="margin-left: -55px"
                >
              </v-form>
            </v-flex>
            <v-flex xs6 class="pl-2">
              <button
                type="button"
                class="faccess_button"
                @click="getUserData()"
                :disabled="!valid || searching_data == ''"
              >
                Consultar
              </button>
            </v-flex>
          </v-layout>
        </div>
      </div>

      <div class="table_card mt-4" v-if="user_finded">
        <div class="table_card__head">
          <p class="table_card__head--title">
            Información de usuario
          </p>
        </div>
        <div class="table_card__body">
          <v-layout row wrap>
            <v-flex xs12 row>
              <v-form onSubmit="return false;" ref="form" v-model="valid" lazy-validation>
                <v-layout row wrap style="background-color: #fff; padding: 0px;">


                <v-flex xs6 style="padding: 8px">
                  <span class="table_card__info--label">Foto</span>
                  <div class="trainers__form--photo_container">
                    <template v-if="getUserType() !== 'Counter'">
                      <label
                        for="trainerPhoto"
                        class="faccess_button buttom_shadow px-5">Examinar</label>
                      <input
                        id="trainerPhoto"
                        type="file"
                        accept=".jpg,.jpeg,image/jpeg"
                        @change="onFileChange"
                        name="photo">
                    </template>
                    <template v-else>
                      <button
                        type="button"
                        class="faccess_button buttom_shadow px-5"
                        @click="openCamera()">
                        Activar camara
                      </button>
                    </template>

                  </div>

                  <button
                    type="button"
                    class="faccess_button buttom_shadow px-5 mt-2"
                    v-if="user.id && isPhotoLinkCompany()"
                    @click="sendPhotoLink()">
                    Enviar link de actualización de foto
                  </button>
                </v-flex>

                <v-flex xs6 style="padding: 8px; " class="classes__image_container mb-4">
                  <div
                    class="data_card__import_img"
                    :style="{backgroundImage: 'url('+ user_url_photo +')'}">
                  </div>

                  <div
                    title="Sincronizar en dispositivos fisicos"
                    class="edit_user_form__sync_button"
                    @click="syncUserOnDevices()"
                    v-if="user_facial_devices && user.user_info_attributes.photo && !user.photo">
                    Sincronizar
                    <span class="material-icons ml-2" style="font-size: 1.2rem;">sync</span>
                  </div>
                </v-flex>

                <v-flex xs6 style="padding: 8px">
                  <v-text-field
                    label="Número de documento:"
                    v-model="user.rut"
                    required>
                  </v-text-field>
                </v-flex>
                <v-flex
                  xs6
                  style="padding: 15px 8px">
                  <v-select
                    item-text="name"
                    item-value="id"
                    v-model="user.document_type"
                    :items="document_types"
                    label="Seleccionar tipo de documento:">
                  </v-select>
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px">
                  <v-text-field
                    label="Nombre:"
                    v-model="user.user_info_attributes.name"
                    required>
                  </v-text-field>
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px">
                  <v-text-field
                    label="Apellido:"
                    v-model="user.user_info_attributes.last_name"
                    required>
                  </v-text-field>
                </v-flex>
                <!-- <label>Teléfono:</label> -->
                <v-flex
                  style="padding: 8px; display: flex; height: 60px;">
                  <vue-country-code
                    style="box-shadow: none;"
                    :default-country="user.country_phone_name"
                    :enabled-country-code="true"
                    @onSelect="selectCountry"
                    @on-select="selectCountry">
                  </vue-country-code>
                  <v-text-field
                    style="padding-left: 10px;"
                    type="tel"
                    label="Teléfono"
                    v-model="user.mobile"
                    required>
                  </v-text-field>
                </v-flex>
                <v-flex
                  xs6
                  style="padding: 8px">
                  <v-text-field
                    label="Correo electrónico:"
                    v-model="user.email"
                    required>
                  </v-text-field>
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 0px 8px">
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="user.user_info_attributes.birthday"
                        label="Fecha de nacimiento:"
                        append-icon="today"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="user.user_info_attributes.birthday"
                      @input="menu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex xs6 style="padding: 0px 8px">
                  <label style="color: gray; font-size: 12px;">Género:</label>
                  <v-radio-group
                    v-model="user.user_info_attributes.gender"
                    row>
                    <v-radio
                      label="Mujer"
                      value="Femenino"
                      color="#1476FB"
                    ></v-radio>
                    <v-radio
                      label="Hombre"
                      value="Masculino"
                      color="#1476FB"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px">
                  <v-text-field
                    type="password"
                    label="Contraseña:"
                    v-model="user.password"
                    :rules="[rules.length]"
                    :change="validatePasswords()"
                    required>
                  </v-text-field>
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px">
                  <v-text-field
                    type="password"
                    label="Confirmación Contraseña:"
                    v-model="user.password_confirmation"
                    :change="validatePasswords()"
                    :rules="[rules.required, rules.length, rules.match]"
                    required>
                  </v-text-field>
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 15px 8px">
                  <v-select
                    item-text="name"
                    item-value="id"
                    v-model="user.user_info_attributes.user_category_id"
                    :items="user_categories"
                    label="Seleccionar plan de usuario:"
                    :disabled="getUserType() === 'Counter'"
                  ></v-select>
                </v-flex>

                <!--v-if="getCompany().payments.admin_payments"-->
                <v-flex
                  xs6
                  style="padding: 15px 8px">

                  <v-text-field
                    label="Inmueble Asignado:"
                    v-model="user.user_info_attributes.sublocation_name"
                    disabled
                    required>
                  </v-text-field>
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px"
                  v-if="user.user_info_attributes.access_state == 'ACTIVO'">
                  <v-text-field
                    label="Fecha inicio del plan:"
                    v-model="user.user_info_attributes.plan_from"
                    disabled
                    required>
                  </v-text-field>
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px"
                  v-if="user.user_info_attributes.access_state == 'ACTIVO'">
                  <v-text-field
                    label="Fecha limite del plan:"
                    v-model="user.user_info_attributes.plan_until"
                    disabled
                    required>
                  </v-text-field>
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px"
                  v-if="user.user_info_attributes.access_state == 'DENEGADO'">
                  <v-text-field
                    label="Estado del plan:"
                    v-model="user.user_info_attributes.access_state"
                    disabled
                    required>
                  </v-text-field>
                </v-flex>

                <v-flex xs6 style="padding: 0px 8px" v-if="getCompany().max_time_exceeded_blocking">
                  <label style="color: gray; font-size: 12px;">Salida de usuario:</label>
                  <v-radio-group
                    v-model="user.blocked"
                    row>
                    <v-radio
                      label="Bloqueado"
                      :value="true"
                      color="#1476FB"
                    ></v-radio>
                    <v-radio
                      label="Desbloqueado"
                      :value="false"
                      color="#1476FB"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>

              </v-layout>
              </v-form>
            </v-flex>
          </v-layout>
        </div>
        <div class="table_card__footer" v-if="user_finded">
          <button
            type="button"
            @click="saveUserInfo()"
            :disabled="!valid_password"
            class="faccess_button"
          >
            Guardar información
          </button>
        </div>
      </div>

      <v-dialog
        v-model="cameraDialog"
        content-class="camera-dialog-modal"
        max-width="50dvw"
        max-height="80dvh"
        transition="dialog-bottom-transition">
        <v-card class="camera-dialog-card" tile flat>
          <div v-if="!cameraVideoReady" class="camera-loader-overlay">
            <div class="camera-spinner"></div>
            <p class="camera-loader-text">Iniciando cámara...</p>
          </div>

          <div
            class="camera-instruction-bar"
            :class="{ 'camera-instruction-bar--ready': faceReady }">
            {{ getFaceDetectionStatusLabel() }}
          </div>

          <v-card-text class="camera-dialog-body">
            <div class="camera-modal-area">
              <div class="camera-video-shell">
                <video
                  ref="cameraVideo"
                  class="camera-preview-video"
                  autoplay
                  playsinline
                  muted
                  @playing="onCameraVideoPlaying">
                </video>
              </div>
              <div
                class="camera-face-indicator"
                :class="{ 'camera-face-indicator--ready': faceReady }">
              </div>
              <div v-if="countdown > 0" class="camera-countdown-overlay">
                {{ countdown }}
              </div>
              <button
                type="button"
                class="camera-close-button"
                @click.stop.prevent="closeCameraDialog()"
                aria-label="Cancelar captura de cámara">
                Cancelar
              </button>
              <canvas ref="cameraCaptureCanvas" class="camera-hidden-canvas"></canvas>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
  </div>
</template>

<script>
import cameraCaptureMixin from './cameraCaptureMixin'

export default {
  mixins: [cameraCaptureMixin],
  data(){
      return{
        searching_data: '',
        menu: false,
        searching_rut: '',
        locations: [],
        user_categories: [],
        document_types: [
          {id: "CD", name: "Carnet Diplomatico"},
          {id: "CC", name: "Cedula de Ciudadania"},
          {id: "CE", name: "Cedula de Extranjeria"},
          {id: "CA", name: "Certificado Cabildo"},
          {id: "IS", name: "Identificación dada por la Secretaria de Educación"},
          {id: "NI", name: "Nit"},
          {id: "PA", name: "Pasaporte"},
          {id: "PE", name: "Permiso Especial de Permanencia"},
          {id: "PPT", name: "Permiso de Protección Temporal"},
          {id: "RC", name: "Registro Civil"},
          {id: "SC", name: "Salvoconducto de Permanencia"},
          {id: "TI", name: "Tarjeta de Identidad"},
          {id: "TM", name: "Tarjeta de Movilidad Fronteriza (tmf)"}
        ],
        user: {
          id:'',
          email: '',
          country_phone_code: '',
          country_phone_name: '',
          mobile: '',
          rut: '',
          document_type: '',
          password: '',
          company_id: '',
          password_confirmation: '',
          blocked: '',
          photo:'',
          user_info_attributes:{
            name: '',
            last_name: '',
            gender: '',
            birthday: new Date().toISOString().substr(0, 10),
            location_id: '',
            sublocation_id: '',
            sublocation_name: '',
            user_category_id: '',
            plan_from: '',
            plan_until: '',
            access_state: ''
          }
        },
        rules: {
          required: value => !!value || 'Requerido',
          length: value => value.length > 5 || 'Mínimo 6 caracteres',
          match: value => value === this.user.password || 'Las contraseñas deben coincidir'
        },
        user_finded: false,
        valid: false,
        valid_password: true,
        user_url_photo: '',
        user_facial_devices: false,
      }
  },
  methods:{
     isPhotoLinkCompany() {
      return this.getCompany().photo_link_enabled;
    },
    selectCountry({name, iso2, dialCode}){
      this.user.country_phone_code = '+' + dialCode
      this.user.country_phone_name = iso2
    },
    validate_data(searching_data){
      let re = /\S+@\S+\.\S+/
      return re.test(searching_data)
    },
    getUserData(){
      this.user.email = ''
      this.user.rut = ''
      if(this.validate_data(this.searching_data)){
        this.user.email = this.searching_data
      }else{
        this.user.rut = this.searching_data
      }
      try {
        this.$http.get('app/users/find_user_by_rut', {
            headers: {
                "X-Device-ID" : this.getDeviceId(),
                "Authorization" : 'Bearer ' + this.getUserToken()
            },
            params:{
              rut: this.user.rut,
              email: this.user.email,
              company_id: this.getCompany().id
            }
        }).then(function(response){
          if(response.body != null){
              var data = response.body.user
              var data_user_info = response.body.user_info
              this.user.id = data.id
              this.user.rut = data.rut
              this.user.document_type = data.document_type
              this.user.email = data.email
              this.user.country_phone_code = data.country_phone_code
              this.user.country_phone_name = data.country_phone_name
              this.user.mobile = data.mobile
              this.user.company_id = data.company
              this.user.blocked = data.blocked
              this.user.photo = ""
              this.user.user_info_attributes.name = data_user_info.name
              this.user.user_info_attributes.last_name = data_user_info.last_name
              this.user.user_info_attributes.photo = data_user_info.picture.url != null ? this.getImageServer() + data_user_info.picture.url : null
              this.user_url_photo = data_user_info.picture.url != null ? this.getImageServer() + data_user_info.picture.url : null
              this.user.user_info_attributes.birthday = data_user_info.birthday != null ? new Date(data_user_info.birthday).toISOString().substr(0, 10) : ''
              this.user.user_info_attributes.location_id = data_user_info.location_id != null ? data_user_info.location_id.toString() : ""
              this.user.user_info_attributes.user_category_id = data_user_info.user_category_id != null ? data_user_info.user_category_id : ""
              this.user.user_info_attributes.plan_from = data_user_info.plan_from != null ? this.$moment(data_user_info.plan_from).format("L") : null
              this.user.user_info_attributes.plan_until = data_user_info.plan_until != null ? this.$moment(data_user_info.plan_until).format("L") : null
              this.user.user_info_attributes.access_state = data_user_info.access_state == "GRANTED" ? "ACTIVO" : "DENEGADO"
              this.user_facial_devices = response.body.facial_devices

              if(response.body.user_sublocation !== null){
                this.user.user_info_attributes.sublocation_id = response.body.user_sublocation.id
                this.user.user_info_attributes.sublocation_name =`${response.body.user_sublocation.name}`
              } else {
                this.user.user_info_attributes.sublocation_name = 'No asignado'
              }
              if(data_user_info.gender != null && data_user_info.gender != ""){
                if(data_user_info.gender === "Male" || data_user_info.gender === "Female"){
                  this.user.user_info_attributes.gender = data_user_info.gender === "Male" ? "Masculino" : "Femenino"
                }else{
                  this.user.user_info_attributes.gender = data_user_info.gender
                }
              }
              // this.user.user_info_attributes.access_state = data.user_info.access_state == "GRANTED" ? "Activo" : "Inactivo"
              if (response.body.user_categories.length > 0) {
                this.user_categories = response.body.user_categories
              }
              this.user_finded = true
          }else{
              this.user_finded = false
              this.updateAlertMessage('No se ha encontrado el usuario con el rut ingresado')
              this.updateIsInAlert(true);
          }
        }, function(response){
          this.user.id = ""
          this.user.rut = ""
          this.user.email = ""
          this.user.country_phone_code = ""
          this.user.country_phone_name = ""
          this.user.mobile = ""
          this.user.photo = ""
          this.user.user_info_attributes.name = ""
          this.user.user_info_attributes.last_name = ""
          this.user.user_info_attributes.gender = ""
          this.user.user_info_attributes.birthday = ""
          this.user.user_info_attributes.location_id = ""
          this.user.user_info_attributes.user_category_id = ""
          this.user_facial_devices = false
          this.user_finded = false

          if (response.status === 403) {
            this.updateAlertMessage('No se encontró un usuario válido para su sede.')
            this.updateIsInAlert(true)
          } else if (response.status === 404) {
            this.updateAlertMessage('No se ha encontrado el usuario con el rut ingresado')
            this.updateIsInAlert(true)
          } else if (response.status === 422 && response.body && response.body.errors && response.body.errors[0]) {
            this.updateAlertMessage(response.body.errors[0].details)
            this.updateIsInAlert(true)
          } else {
            this.updateAlertMessage('No se ha encontrado el usuario con el rut ingresado')
            this.updateIsInAlert(true)
          }
        })
      } catch (e) {
          this.updateAlertMessage(e.message)
          this.updateIsInAlert(true);
      }
    },
    saveUserInfo(){
      if(this.validateMobile()){
        var vm = this;
        var data = vm.user;
        try {
          this.$http.post('users/update_client_data_by_counter',{
            data: this.encrypt(data).toString(),
            attributes:this.encrypt(data).toString()
          },
          {
            headers: {
              "X-Device-ID" : this.getDeviceId(),
              "Authorization" : 'Bearer ' + this.getUserToken()
            }

          }).then(
            function(response) {
              if (
                response.body.meta != undefined &&
                response.body.meta != null
              ) {
                if (
                  response.body.meta.authentication_token != undefined &&
                  response.body.meta.authentication_token != null
                ) {
                  this.checkToken(response.body.meta.authentication_token);
                }
              }
              if (response.body && response.status == 201) {
                var savedAns = response.body.ans
                var userId = this.user.id
                var hadFacialDevices = this.user_facial_devices
                var hadNewPhoto = !!(this.user.photo && String(this.user.photo).trim() !== '')
                this.user_finded = false
                this.searching_rut = ''
                var shouldAutoSync = hadFacialDevices && userId && hadNewPhoto
                if (shouldAutoSync) {
                  this.postSyncUserOnDevices(userId).then(function (res) {
                    if (res.body && res.status == 200 && res.body.ans) {
                      this.updateAlertMessage(savedAns + ' · ' + res.body.ans)
                    } else {
                      this.updateAlertMessage(savedAns)
                    }
                    this.updateIsInAlert(true)
                  }.bind(this)).catch(function (e) {
                    this.updateAlertMessage(savedAns + ' · Sincronización: ' + this.getSyncErrorMessage(e))
                    this.updateIsInAlert(true)
                  }.bind(this))
                } else {
                  this.updateAlertMessage(savedAns)
                  this.updateIsInAlert(true)
                }
              }
            },
            function(response) {
              if (
                response.body.meta != undefined &&
                response.body.meta != null
              ) {
                if (
                  response.body.meta.authentication_token != undefined &&
                  response.body.meta.authentication_token != null
                ) {
                  this.checkToken(response.body.meta.authentication_token);
                }
              }
              if (response.status === 403) {
                this.updateAlertMessage('No está autorizado para editar este usuario.')
                this.updateIsInAlert(true)
              } else if (response.status === 404 && response.body && response.body.errors && response.body.errors[0]) {
                this.updateAlertMessage(response.body.errors[0].details || 'No se encontró el usuario.')
                this.updateIsInAlert(true)
              } else if (response.status === 422 && response.body && response.body.errors && response.body.errors[0]) {
                this.updateAlertMessage(response.body.errors[0].details);
                this.updateIsInAlert(true);
              } else {
                this.updateAlertMessage('No se pudo actualizar la información del usuario.')
                this.updateIsInAlert(true)
              }
            }
          );
        } catch (e) {
          this.updateAlertMessage(e.message);
          this.updateIsInAlert(true);
        }
      } else {
        this.updateAlertMessage("Por favor ingresa un número de teléfono válido");
        this.updateIsInAlert(true);
      }
    },
    validateMobile(){
      return !this.user.mobile.match(/[A-Za-z]+/g)
    },
    validatePasswords(){
      let user = this.user
      if (user.password === '' && user.password_confirmation === '' || (user.password === user.password_confirmation && user.password.length > 5)){
        this.valid_password = true
      }
      else if(user.password != '' && user.password_confirmation === '' || user.password !== user.password_confirmation || user.password.length < 6){
        this.valid_password = false
      }
    },
    getSyncErrorMessage (e) {
      try {
        if (e && e.body && e.body.errors && e.body.errors[0] && e.body.errors[0].details) {
          return String(e.body.errors[0].details)
        }
        if (e && e.body && e.body.details) {
          return String(e.body.details)
        }
        if (e && e.message) {
          return String(e.message)
        }
      } catch (err) {
        // ignore
      }
      return 'No se pudo sincronizar con los dispositivos'
    },
    postSyncUserOnDevices (userId) {
      var payload = {
        user_id: userId
      }
      return this.$http.post('users/sync_user_on_devices', {
        data: this.encrypt(payload).toString()
      },
      {
        headers: {
          "X-Device-ID" : this.getDeviceId(),
          "Authorization" : 'Bearer ' + this.getUserToken()
        }
      })
    },
    syncUserOnDevices () {
      if (!this.user || !this.user.id) {
        this.updateAlertMessage('No hay usuario para sincronizar')
        this.updateIsInAlert(true)
        return
      }
      this.postSyncUserOnDevices(this.user.id).then(function (res) {
        if (res.body && res.status == 200) {
          this.updateAlertMessage(res.body.ans)
          this.updateIsInAlert(true)
        }
      }.bind(this)).catch(function (e) {
        this.updateAlertMessage(this.getSyncErrorMessage(e))
        this.updateIsInAlert(true)
      }.bind(this))
    },
    async sendPhotoLink () {
      if (!this.user || !this.user.id) {
        this.updateAlertMessage('Busca un usuario antes de enviar el link')
        this.updateIsInAlert(true)
        return
      }
      const payload = {
        user_id: this.user.id,
        company_id: this.user.company_id || this.getCompany().id
      }
      try {
        const res = await this.$http.post('users/photos/link', payload, {
          headers: {
            "X-Device-ID": this.getDeviceId(),
            "Authorization": 'Bearer ' + this.getUserToken()
          }
        })
        this.updateAlertMessage(res.body.ans)
        this.updateIsInAlert(true)
      } catch (e) {
        let msg = 'No se pudo enviar el link'
        if (e && e.body) {
          msg = e.body.ans || (e.body.errors && e.body.errors[0] && e.body.errors[0].details) || msg
        }
        this.updateAlertMessage(msg)
        this.updateIsInAlert(true)
      }
    }
  }
}
</script>

<style>
.camera-dialog-modal {
  box-shadow: none !important;
}

.camera-dialog-modal .v-dialog {
  margin: 24px auto !important;
}

.camera-dialog-card {
  position: relative;
  width: 100%;
  aspect-ratio: 9 / 16;
  max-height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
  background-color: #e8eaed !important;
  border-radius: 10px !important;
  overflow: hidden;
  max-height: 80dvh;
}

.v-dialog.camera-dialog-modal .camera-dialog-card {
  display: flex !important;
  flex-direction: column !important;
}

.v-dialog.camera-dialog-modal .camera-dialog-card .camera-dialog-body {
  flex: 1 1 auto !important;
  min-height: 0 !important;
}

.camera-close-button {
  position: absolute;
  left: 50%;
  bottom: max(28px, env(safe-area-inset-bottom, 0px));
  transform: translateX(-50%);
  z-index: 30;
  border: 1px solid #d7dee8;
  background: #f5f7fa;
  color: #697588;
  min-width: 150px;
  height: 56px;
  border-radius: 10px;
  font: normal normal 600 18px 'Poppins';
  letter-spacing: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0px 6px 18px rgba(0, 0, 0, 0.28);
  transition: background 0.2s ease, color 0.2s ease;
  pointer-events: auto;
}

.camera-close-button:active {
  transform: translateX(-50%) scale(0.98);
}

.camera-loader-overlay {
  position: absolute;
  inset: 0;
  z-index: 3000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #ededed;
}

.camera-spinner {
  width: 50px;
  height: 50px;
  border: 5px solid rgba(46, 163, 198, 0.2);
  border-top-color: #1476FB;
  border-radius: 50%;
  animation: camera-spin 1s linear infinite;
  margin-bottom: 15px;
}

.camera-loader-text {
  color: #1476FB;
  font-weight: 600;
  font-family: sans-serif;
  font-size: 16px;
}

@keyframes camera-spin {
  to {
    transform: rotate(360deg);
  }
}

.camera-instruction-bar {
  flex-shrink: 0;
  min-height: 64px;
  padding: 16px 20px;
  background: #1476FB;
  color: #fff;
  font: normal normal 600 140% 'Poppins';
  letter-spacing: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  z-index: 1090;
  transition: background-color 0.3s ease;
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.06);
}

.camera-instruction-bar--ready {
  background: #00897b;
}

.camera-dialog-body {
  flex: 1;
  position: relative;
  padding: 0 !important;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: auto;
}

.camera-modal-area {
  position: relative;
  flex: 1;
  width: 100%;
  height: auto;
  background: #050505;
}

.camera-video-shell {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #000;
}

.camera-preview-video {
  display: block;
  width: 100%;
  height: 100%;
  min-width: 100%;
  min-height: 100%;
  max-width: none;
  max-height: none;
  object-fit: cover;
  object-position: center;
  transform: scaleX(-1);
  background: #000;
}

.camera-face-indicator {
  position: absolute;
  width: 50%;
  min-width: 140px;
  max-width: none;
  aspect-ratio: 1 / 1;
  height: auto;
  border-radius: 50%;
  border: 7px solid rgba(229, 57, 53, 0.98);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  z-index: 2;
  transition: border-color 0.25s ease, box-shadow 0.25s ease;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.15);
}

.camera-face-indicator--ready {
  border-color: #00ff88;
}

.camera-countdown-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: clamp(80px, 22vw, 160px);
  font-weight: 700;
  color: #fff;
  background: rgba(0, 0, 0, 0.35);
  z-index: 4;
  pointer-events: none;
}

.camera-hidden-canvas {
  display: none;
}

</style>



// WEBPACK FOOTER //
// src/components/views/users/EditUser.vue